var __react_jsx__ = require('react');
var _J$X_ = (__react_jsx__["default"] || __react_jsx__).createElement;
(__react_jsx__["default"] || __react_jsx__).Fragment;
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/_J$X_("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/_J$X_("path", {
    fillRule: "evenodd",
    d: "m21.09 5.71-12 12-5.68-5.63a.502.502 0 0 0-.71.71l6.36 6.36L21.8 6.42a.502.502 0 0 0-.71-.71Z",
    clipRule: "evenodd"
  })));
};

export { SvgCheck as ReactComponent };
